import { useToast, Box, CloseButton } from '@chakra-ui/react'
import React from 'react'
import toastStyle from '../../Theme/components/toastStyle'

const ToastComponent = () => {
  const toast = useToast()
  
  const closeToast = () => {
    toast.close('toast-id');
  }

  const showErrorToast = (message: string) => {
    toast({
      id: 'toast-id',
      duration: 7000,
      position: 'bottom-left',
      status: 'error',
      render: () => (
        <Box style={toastStyle.toastError} pos='relative' data-testid='errorToast-id'>
          {message}
          <CloseButton onClick={closeToast} type='button' data-testid='close-toast' style={{ position: 'absolute', right: '16px' }} />
        </Box>
      ),
    })
  }
  

  return { showErrorToast, closeToast }
}

export default ToastComponent